// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__24Yjx","label":"TextInput_label__sDlYA","input":"TextInput_input__vUxVT","error":"TextInput_error__3X8no"};